import { Outlet, Link, useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";

export default function Layout() {
  const { user, clearAuth } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAuth();
    navigate("/");
  };

  return (
    <>
      {/* Header */}
      <header className="bg-dark-800 border-b border-dark-border sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <Link to="/dashboard" className="text-2xl font-bold text-primary-500 flex items-center gap-2">
              <span>🦞</span>
              <span>Clawplete</span>
            </Link>
            <nav className="flex items-center gap-6">
              <Link to="/dashboard" className="nav-link">
                Dashboard
              </Link>
              {/* TODO: remove /surveys route in production */}
              <Link to="/wallet" className="nav-link">
                Wallet
              </Link>
              <Link to="/profile" className="nav-link">
                Profile
              </Link>
              {user?.role === "admin" && (
                <Link to="/admin" className="nav-link text-purple-400 hover:text-purple-300">
                  Admin
                </Link>
              )}
              <button
                onClick={handleLogout}
                className="px-4 py-2 text-sm font-medium text-gray-400 hover:text-white transition-colors"
              >
                Logout
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="min-h-screen bg-dark-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Outlet />
        </div>
      </main>
    </>
  );
}
